import React from "react";
import styles from "./ChoiceList.module.css";
import { CheckIcon } from "../icons/icons";

/* Reusable single-select option list (radio group). `value` is the selected
   option object; onSelect(option) reports the choice up. */
const ChoiceList = ({ name, options, value, onSelect, ariaLabel }) => (
  <div className={styles.options} role="radiogroup" aria-label={ariaLabel}>
    {options.map((opt) => {
      const selected = value && value.label === opt.label;
      return (
        <button
          key={opt.label}
          type="button"
          role="radio"
          aria-checked={selected}
          name={name}
          className={`${styles.option} ${selected ? styles.optionSelected : ""}`}
          onClick={() => onSelect(opt)}
        >
          <span className={styles.optionMark}>
            <CheckIcon />
          </span>
          <span className={styles.optionBody}>
            <span className={styles.optionLabel}>{opt.label}</span>
            {opt.sub && <span className={styles.optionSub}>{opt.sub}</span>}
          </span>
        </button>
      );
    })}
  </div>
);

export default ChoiceList;
